export const environment = {
  production: true,
  sentryEnabled: true,
  apiUrl: "/api",
  msGraphClientId: "59b64115-f293-44e6-9c4c-fef3a2b8503e",
  version: "efca3781ddec32b195d3446299e9cfa0833a219e",
  googleApiKey: window.location.href.includes("suus.quotiss.com")
    ? "AIzaSyAJaLaJU_ZBx439flqxIwqpbEjKMh8xFn0"
    : "AIzaSyDgFw-Y367XXBJvdPBGs--DUKw-nHw7RQs",
  isCompareSurchargesEnabled: window.location.href.includes(
    "crosstrades.quotiss.com",
  )
    ? false
    : true,
};
